import React, { useState } from 'react'

import { Button } from '@material-ui/core'

import { LoadingFeedback, MenuButton } from 'components'

import useSnackbar from 'hooks/useSnackbar'

import helpers from 'helpers'
import * as service from 'service'

const Actions = ({ companySupplier }) => {
  const [isLoading, setIsLoading] = useState(false)
  const snackbar = useSnackbar()

  const handleAnswer = async () => {
    const newWindow = window.open('about:blank', '_blank')
    setIsLoading(true)

    try {
      const response = await service.dponet.suppliers.accessToSupplierPortal({
        companySupplierId: companySupplier.id,
      })

      const url = new URL(companySupplier.supplierPortalLink)
      url.searchParams.set('redirect_token', response?.data?.authToken)

      newWindow.location.href = url.toString()
    } catch (error) {
      if (newWindow) newWindow.close()
      snackbar.open({
        message:
          helpers.formatters.errorMessage(error?.response?.data?.error) ||
          'Erro ao acessar portal do fornecedor.',
        variant: 'error',
      })
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <>
      <LoadingFeedback open={isLoading} />
      <MenuButton>
        <Button color="secondary" fullWidth onClick={handleAnswer}>
          Responder
        </Button>
      </MenuButton>
    </>
  )
}

export default Actions
